module.exports = __webpack_public_path__ + "static/media/setting.f415e4ee.svg";